<template>
  <div v-if="computedAdditionals">
    <h2>Additionals</h2>
    <v-btn @click="convertAdditionals">Convert additionals</v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedAdditionals"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'additional', params: { id: props.item.id } }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>
            <span v-if="props.item.locked" style="color: red">unpublished</span>
            <span v-if="!props.item.locked" style="color: green"
              >published</span
            >
          </td>
          <td>
            <EntityZ
              :entity="props.item.user"
              v-if="props.item.user"
              format="system"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>{{ props.item.timestamp | formatDateTime }}</td>
          <td>
            <v-btn @click="cloneAdditional(props.item)" small>
              <v-icon>file_copy</v-icon>Clone
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Additionals",
  metaInfo() {
    return {
      title: "Additionals",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    computedAdditionals() {
      if (!this.additionals) {
        return undefined;
      }
      return this.additionals.map((a) => {
        const user = this.entities ? this.entities[a.userid] : undefined;
        return { ...a, user };
      });
    }
  },
  data() {
    return {
      additionals: null,
      entities: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Status",
          value: "status"
        },
        {
          text: "User",
          value: "userid"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    async fetchAdditionals() {
      const response = await nbmlaw.get(`/cors/admin/sales/additionals`);
      // console.log(response.data);
      this.additionals = response.data;
    },
    async fetchEntities() {
      const response = await nbmlaw.get(`/cors/admin/sales/additionals/users`);
      // console.log(response.data);
      this.entities = response.data;
    },
    async cloneAdditional(additional) {
      if (confirm("Are you sure?")) {
        const response = await nbmlaw.post(
          `/cors/admin/sales/additionals/${additional.id}/clone`,
          null
        );
        // console.log(response.data);
        this.$router.push({
          name: "additional",
          params: { id: response.data }
        });
      }
    },
    async convertAdditionals() {
      if (confirm("Are you sure?")) {
        await nbmlaw.put(`/cors/admin/sales/additionals`, null);
        this.fetchAdditionals();
      }
    }
  },
  created() {
    this.fetchAdditionals();
    this.fetchEntities();
  }
};
</script>